
import React, { useState } from "react";
import './index.scss';
import { useInterval } from "@/utils/Hooks";
import { HistoryPush } from "@/Interface";

const FunctionCard = ({ title, description, id, img, hover, routePath, duration, isSmallCard = false }) => {
    let currentTimer = 0

    useInterval(() => {
        currentTimer += 500
        if (currentTimer >= duration) {
            currentTimer = 0
            resetHoverImg(id)
        }
    }, 500)

    const handleClickItem = (routePath) => {
        HistoryPush(routePath)
    }

    const resetHoverImg = (id) => {
        const curWebp = document.getElementById(`${id}-image`)
        if (curWebp) {
            curWebp.src = '';
            curWebp.src = `/images/common/ai/tools/${hover}`;
        }
    }

    return (
        <div className={`function-card-item ${isSmallCard ? "small-card" : ""}`} onClick={() => handleClickItem(routePath)}>
            <div className="function-card-item-top-area">
                <div className="function-card-item-title">
                    {title}
                </div>
                <div className="function-card-item-description">
                    {description}
                </div>
            </div>
            <div className="function-card-item-image">
                <img id={`${id}-image`} src={`/images/common/ai/tools/${hover}`} alt="thumb" />
            </div>
        </div>
    )
}

export default FunctionCard;